// extracted by mini-css-extract-plugin
module.exports = {"md":"branch-list_md_2ge1t","ios":"branch-list_ios_2WAUj","list":"branch-list_list_3Jfnq","phone":"branch-list_phone_2IAYm","time":"branch-list_time_2zS0w"};